export const VIDEO_ELEMENT_DEFAULT_ATTRS: Partial<HTMLVideoElement> = {
  autoplay: false,
  muted: true,
  controls: true,
};
